import { ChatbotData } from '../../../model/Configuration'

const CHATBOT_CHANGE = 'CHATBOT/CHANGE';

export default function chatbotChangeAction (chatbotData: ChatbotData) {
  return {
    type: CHATBOT_CHANGE,
    payload: { 
        chatbot: chatbotData
     }
  };
}

export { CHATBOT_CHANGE };